module.exports = __webpack_public_path__ + "static_pest_wiki_details/img/bieshu_infobanner01.927e13f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/product_info/bieshu_infobanner01.png
// module id = abDc
// module chunks = 0